import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Iconbox from "../../src/assets/Group 5.png";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Link } from "react-router-dom";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import initializeAOS from "../utils/aosLibrary";
import { useMediaQuery } from "@mui/material";

function PrivacyPolicy() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const fontLivic = "Livvic , sans-serif";
  useEffect(() => {
    document.title = "Privacy Policy – Protecting Your Data and Privacy";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Learn how we collect, use, and protect your personal data. Our Privacy Policy ensures transparency and security to safeguard your privacy rights."
    );
    initializeAOS();
  }, []);

  return (
    <>
      <Navbar />
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            data-aos="fade-up"
            style={{
              fontSize: isXs ?"64px":"50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            Privacy Policy
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "black",
            fontFamily: fontLivic,
            fontSize: "18px",
            textAlign: "center",
          }}
        ></div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            position: "absolute",
            right: "0",
            top: "200px",
            display: isXs ? "flex" : "none",
          }}
          src={line_vector}
          alt=""
        />
      </div>

      <div style={{ padding: isXs ? "90px 150px" : "90px 30px" }}>
        <div
          style={{ fontSize: "48px", fontWeight: "600", margin: "20px 0px" }}
        >
          Introduction
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
          }}
        >
          Welcome to MadStack. This Privacy Policy explains how we collect, use,
          disclose, and safeguard your personal information when you engage with
          our products and services.{" "}
        </div>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          1. Information We Collect
        </div>
        <ul
          style={{
            display: "flex",
            gap: "15px",
            flexDirection: "column",
            paddingLeft: "40px",
          }}
        >
          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Personal Information:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                {" "}
                We may collect information such as your name, contact details,
                billing information, and any data you provide when interacting
                with us.
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Usage Data:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                {" "}
                We may collect information such as your name, contact details,
                billing information, and any data you provide when interacting
                with us.
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Cookies and Similar Technologies:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                {" "}
                We may collect information such as your name, contact details,
                billing information, and any data you provide when interacting
                with us.
              </span>
            </div>
          </li>
        </ul>

        <div
          style={{
            fontSize: "24px",
            fontWeight: "600",
            margin: "24px 0px 0px 0px",
          }}
        >
          2. How We Use Your Information
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
            paddingBottom: "20px",
          }}
        >
          We use your information for the following purposes:{" "}
        </div>

        <ul
          style={{
            display: "flex",
            gap: "15px",
            flexDirection: "column",
            paddingLeft: "40px",
          }}
        >
          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Service Delivery:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                To provide, maintain, and improve our products and services.{" "}
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Customer Interaction:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                {" "}
                To communicate updates, respond to inquiries, and provide
                customer support.
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Analytics:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                To analyze trends and usage patterns to optimize user
                experience.{" "}
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Customization:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                To tailor content and advertising according to your preferences.
              </span>
            </div>
          </li>
        </ul>

        <div
          style={{
            fontSize: "24px",
            fontWeight: "600",
            margin: "24px 0px 0px 0px",
          }}
        >
          3. Sharing Your Information{" "}
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
            paddingBottom: "20px",
          }}
        >
          We may share your information in the following ways:{" "}
        </div>

        <ul
          style={{
            display: "flex",
            gap: "15px",
            flexDirection: "column",
            paddingLeft: "40px",
          }}
        >
          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Service Providers:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                With trusted vendors and contractors who support our operations.
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Business Collaborations:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                {" "}
                With partners who help enhance our offerings.{" "}
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Legal Obligations:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                When required to comply with legal processes or regulatory
                requirements.{" "}
              </span>
            </div>
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          4. Your Choices{" "}
        </div>
        <ul
          style={{
            display: "flex",
            gap: "15px",
            flexDirection: "column",
            paddingLeft: "40px",
          }}
        >
          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Opt-Out:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                {" "}
                You can opt out of receiving marketing communications and
                certain types of data collection.
              </span>
            </div>
          </li>

          <li>
            <div>
              {" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                Access and Correction:
              </span>{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontFamily: fontLivic,
                  letterSpacing: "0.67",
                  color: "#4A4A4A",
                }}
              >
                You have the right to request access to or correction of your
                personal information.{" "}
              </span>
            </div>
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          5. Security{" "}
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
          }}
        >
          We prioritize the security of your information by implementing
          industry-standard practices to protect against unauthorized access,
          alteration, or disclosure.
        </div>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          6. Data Retention
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
          }}
        >
          Your information is retained only for as long as necessary to fulfill
          the purposes outlined in this Privacy Policy or as required by law.{" "}
        </div>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          7. Children's Privacy
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
          }}
        >
          Our services are not intended for individuals under 18. We do not
          knowingly collect personal information from minors.
        </div>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          8. Changes to this Privacy Policy
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
          }}
        >
          We may revise this Privacy Policy from time to time. Updates will be
          posted on our website, and significant changes will be communicated to
          you.{" "}
        </div>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          9. Contact Us
        </div>
        <div
          style={{
            fontSize: "18px",
            fontFamily: fontLivic,
            letterSpacing: "0.67",
            color: "#4A4A4A",
            paddingLeft: "25px",
          }}
        >
          If you have questions, concerns, or requests related to this Privacy
          Policy, please{" "}
          <Link style={{ textDecoration: "none" }} to="/contact-us">
            {" "}
            contact us
          </Link>{" "}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default PrivacyPolicy;
